"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureDate = exports.calculateInvoice = void 0;
function calculateInvoice(offer, move, configuration) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const vatRate = 0.19;
    const additionalServices = (_e = (_d = (_c = (_b = (_a = move.documentData) === null || _a === void 0 ? void 0 : _a.invoice) === null || _b === void 0 ? void 0 : _b.additionalServices) === null || _c === void 0 ? void 0 : _c.map((service) => {
        const predefined = configuration.invoiceItems.find((item) => item.id === service.predefinedId);
        return { service, predefined };
    }).filter((entry) => entry.predefined != null)) === null || _d === void 0 ? void 0 : _d.map(({ service, predefined }, i) => {
        return {
            name: predefined.name,
            amount: predefined.unit != null ? service.amount || 0 : 0,
            price: predefined.unit != null && (predefined.price || 0) > 0
                ? (predefined.price || 0) * (service.amount || 0)
                : service.price || 0,
            unitPrice: predefined.unit != null && (predefined.price || 0) > 0
                ? predefined.price
                : undefined,
            unit: predefined.unit,
        };
    })) !== null && _e !== void 0 ? _e : [];
    const total = offer.positionsSum +
        additionalServices.reduce((sum, service) => sum + service.price, 0);
    return {
        movePrice: offer.positionsSum,
        additionalServices,
        number: (_g = (_f = move.documentData) === null || _f === void 0 ? void 0 : _f.invoice) === null || _g === void 0 ? void 0 : _g.number,
        date: ensureDate((_j = (_h = move.documentData) === null || _h === void 0 ? void 0 : _h.invoice) === null || _j === void 0 ? void 0 : _j.date),
        total,
        totalGross: total * (1 + vatRate) + offer.insuranceFee,
        vatRate,
        vat: total * vatRate,
    };
}
exports.calculateInvoice = calculateInvoice;
function ensureDate(date) {
    if (date == null)
        return undefined;
    const parsedDate = date instanceof Date ? date : new Date(date);
    return isNaN(parsedDate.getTime()) ? undefined : parsedDate;
}
exports.ensureDate = ensureDate;
//# sourceMappingURL=invoice.js.map